import { uniq } from "lodash-es"
import { ExpectationConfiguration } from "src/api/graphql/graphql.ts"
import { getExpectationGroupName } from "src/global/utils/getExpectationGroupName.ts"
import { pluralize } from "src/global/utils/strings.ts"
import { sortAscWithTableExpectationsFirst } from "src/global/utils/sortAscWithTableExpectationsFirst.ts"
import { nonNull } from "src/global/utils/nonNull.ts"

export const getColumnsFromExpectationsList = (
  expectationsList: ExpectationConfiguration[] | undefined,
  search: string,
) => {
  const listResult =
    expectationsList
      ?.filter(nonNull)
      .map(getExpectationGroupName)
      .filter((group) => group.toLowerCase().includes(search.toLowerCase()))
      .sort(sortAscWithTableExpectationsFirst) ?? []
  return uniq(listResult)
}

export const getSubtitle = (expectationCount: number, loading: boolean) => {
  const expectationsSubtitle = String(expectationCount) + " " + pluralize("Expectation", expectationCount)

  return loading ? "" : `${expectationsSubtitle}`
}
